import { Component } from "react";
import { DataGrid } from "@material-ui/data-grid";
const columns = [
  {
    field: "tva",
    headerName: "Titre du libelle",
    width: 150,
    editable: true,
  },
  {
    field: "buyinfPrice",
    headerName: "Montant",
    width: 150,
    editable: true,
  },
];

class ExtratFacture extends Component {
  testPrice(extrat) {
    if (extrat?.finalPriceTt) {
      return <td>{extrat?.finalPriceTt} {extrat?.currency}</td>;
    } else {
      return <td>{extrat?.priceTt} {extrat?.currency}</td>;
    }
  }
  render() {
    if (this.props.extracts?.length === 0) {
      return (
        <div className="row">
          <div className="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row" style={{ marginTop: 30, marginLeft: 10 }}>
          <div className="col-xs-12 table-responsive">
            <p className="lead">Les produits:</p>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Libelle</th>
                  <th>Montant</th>
                  <th>Quantité</th>
                </tr>
              </thead>

              <tbody>
                {this.props.extracts &&
                  this.props.extracts.map((extrat) => (
                    <tr key={extrat.id}>
                      <td>{extrat.product?.name}</td>
                      {this.testPrice(extrat)}

                      <td>{extrat?.quantity}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
}
export default ExtratFacture;
